import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { HttpLaravelHeaders } from '@app/_interceptors/url.interceptor';
import { DataList } from '@app/_shared/interfaces/http/data';
import { Notification } from '@app/_shared/interfaces/http/notification';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NotificationsService {
  private http = inject(HttpClient);

  private headers = new HttpLaravelHeaders();
  private endpoint = '/api/v1/user/notifications';

  index(): Observable<DataList<Notification>> {
    return this.http.get<DataList<Notification>>(this.endpoint, {
      headers: this.headers,
    });
  }

  markAllAsRead(): Observable<void> {
    return this.http.post<void>(`${this.endpoint}/read`, null, {
      headers: this.headers,
    });
  }
}
